module.exports = __webpack_public_path__ + "img/g-mobile.abdc8d50.jpg";